<div class="container-table">
  <mat-table
    #table
    class="table table-p1 borderless align-middle"
    matSortDisableClear
    [dataSource]="dataSource"
    matSort
    matSortDirection="desc"
  >
    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Ordem</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Ordem:</span>
        <div class="order-cell-container">
          <div class="order-id-row">
            <p
              class="tappable label-desktop order-id"
              (click)="goOrderDetail(row?.id)"
            >
              {{ row?.id }}
            </p>
            <img
              *ngIf="row?.remmitanceType === 'OUTBOUND'"
              src="assets/image/icon-enviar.svg"
              alt="Enviar"
              class="order-arrow"
            />
            <img
              *ngIf="row?.remmitanceType === 'INBOUND'"
              src="assets/image/icon-receber.svg"
              alt="Receber"
              class="order-arrow"
            />
          </div>
          <span
            *ngIf="row?.remmitanceType === 'OUTBOUND'"
            class="order-type-label"
          >
            Enviar
          </span>
          <span
            *ngIf="row?.remmitanceType === 'INBOUND'"
            class="order-type-label"
          >
            Receber
          </span>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="clientInfo">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Cliente</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Cliente:</span>

        <span class="label-desktop label-data label-elipsis">
          <span
            *ngIf="row?.tipoPessoa == 'PJ'"
            [title]="row?.corporateAccount?.companyName"
            class="label-desktop"
          >
            {{ row?.corporateAccount?.companyName }}
          </span>
          <span
            *ngIf="row?.tipoPessoa == 'PF'"
            [title]="row?.individualAccount?.name"
            class="label-desktop"
          >
            {{ row?.individualAccount?.name }}
          </span>
          <br />
          <span *ngIf="row?.tipoPessoa == 'PJ'" class="label-desktop-bold">
            CNPJ:
          </span>
          <span *ngIf="row?.tipoPessoa == 'PF'" class="label-desktop-bold">
            CPF:
          </span>
          <span
            *ngIf="row?.tipoPessoa == 'PJ'"
            [title]="row?.corporateAccount?.cnpj"
            class="label-desktop"
            >{{
              row?.corporateAccount?.cnpj | mask: "AA.AAA.AAA/AAAA-00"
            }}</span
          >

          <span
            *ngIf="row?.tipoPessoa == 'PF'"
            [title]="row?.individualAccount?.cpf"
            class="label-desktop label-data"
          >
            {{ row?.individualAccount?.cpf | mask: "000.000.000-00" }}
          </span>
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="createdDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Data de criação</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Data de criação:</span>

        <span class="label-desktop label-data">
          {{ row?.createdDate | date: "dd/MM/yyyy" }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="companyName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Nome do cliente</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Nome do cliente:</span>

        <span *ngIf="row?.tipoPessoa == 'PJ'" class="label-desktop label-data">
          {{ row?.corporateAccount?.companyName }}
        </span>
        <span *ngIf="row?.tipoPessoa == 'PF'" class="label-desktop label-data">
          {{ row?.individualAccount?.name }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="cnpj">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Doc. do cliente</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Doc. do cliente:</span>

        <span *ngIf="row?.tipoPessoa == 'PJ'" class="label-desktop label-data">
          {{ row?.corporateAccount.cnpj | mask: "AA.AAA.AAA/AAAA-00" }}
        </span>

        <span *ngIf="row?.tipoPessoa == 'PF'" class="label-desktop label-data">
          {{ row?.individualAccount?.cpf | mask: "000.000.000-00" }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="amount">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Valor</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Valor:</span>

        <div *ngIf="row?.currency?.description">
          <span class="label-desktop">{{ row?.currency?.description }} </span
          ><span class="label-desktop-amount">{{
            row?.amount | amountPipe
          }}</span>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="slipCode">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Nº do boleto</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Nº do boleto:</span>
        <span
          *ngIf="row?.slipCode"
          [title]="row?.slipCode"
          class="label-desktop label-data slip-code-container"
        >
          {{ row?.slipCode }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="orderSource">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Origem</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Origem:</span>

        <div
          *ngIf="row?.orderSource === 'HOMEBROKER'"
          class="chip-platform chip-pink"
          title="Plataforma"
        >
          Plataforma
        </div>

        <div
          *ngIf="row?.orderSource === 'PARTNER'"
          class="chip-platform chip-blue"
          title="Parceiro"
        >
          Parceiro
        </div>

        <div
          *ngIf="row?.orderSource === 'ADMIN'"
          class="chip-platform chip-order-by-admin"
          title="Operação"
        >
          Operação
        </div>

        <div
          *ngIf="row?.orderSource === 'EXCHANGE'"
          class="chip-platform chip-exchange"
          title="Exchange"
        >
          Exchange
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="tipoPessoa">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <p class="label-desktop">Cadastro</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span class="mobile-label">Cadastro:</span>

        <span class="label-desktop label-data text-center">
          {{ row?.tipoPessoa }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef>
        <p class="label-desktop">Status</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span
          class="size-row label-data"
          [title]="row?.additionalFlowLabel"
        >
          {{ row?.additionalFlowLabel }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef>
        <p class="label-desktop">Ações</p>
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index">
        <span
          *ngIf="row?.orderSource != 'EXCHANGE'"
          class="size-row label-data tappable"
          (click)="goOrderDetail(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/view-details.svg"
        /></span>

        <span
          *ngIf="row?.orderSource == 'EXCHANGE'"
          class="size-row label-data tappable"
          (click)="goOrderDetail(row?.id)"
          ><img
            class="pr-2"
            src="assets/image/tooltips/view-exchange-details.svg"
        /></span>

        <span
          *ngIf="row?.statusFlow == 'PROCESSING'"
          class="size-row label-data tappable"
          title="Analisar a ordem"
          (click)="openOrderReviewModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/review-order.svg"
        /></span>

        <span
          *ngIf="
            row?.remmitanceType == 'OUTBOUND' &&
            row?.orderSettlement?.proofOperationLater &&
            !row?.orderSettlement?.proofOperationFile
          "
          class="size-row label-data tappable"
          title="Anexar os comprovantes"
          (click)="openAttachProofOperationModal(row?.id)"
          ><img
            class="pr-2"
            src="assets/image/tooltips/upload-proof-operation.svg"
        /></span>
        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            row?.confirmationTreasury &&
            row?.confirmationSlip &&
            row?.effected &&
            row?.remmitanceType == 'OUTBOUND' &&
            !row?.orderSettlement?.exchangeContractFile
          "
          class="size-row label-data tappable"
          title="Enviar contrato"
          (click)="openSendContractModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/send-contract.svg"
        /></span>
        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            row?.confirmationTreasury &&
            row?.confirmationSlip &&
            row?.effected &&
            row?.remmitanceType == 'OUTBOUND' &&
            row?.orderSettlement?.exchangeContractFile
          "
          class="size-row label-data tappable"
          title="Reenviar contrato"
          (click)="openSendContractModal(row?.id)"
          ><img
            class="pr-2"
            src="assets/image/tooltips/send-contract-success.svg"
        /></span>
        <span
          *ngIf="
            (!row?.orderSettlement?.exchangeContractFile ||
              !row?.orderSettlement?.proofOperationFile ||
              row?.orderSettlement?.orderSettlementAttachments?.length == 0) &&
            row?.orderSource == 'EXCHANGE' &&
            !row?.orderSettlement?.proofOperationFileApproved
          "
          class="size-row label-data tappable"
          title="Anexar os documentos da liquidação e operação"
          (click)="openSettlementDocumentsComponentModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/upload-documents.svg"
        /></span>

        <span
          *ngIf="
            (!row?.orderSettlement?.exchangeContractFile ||
              !row?.orderSettlement?.proofOperationFile ||
              row?.orderSettlement?.orderSettlementAttachments?.length == 0) &&
            row?.orderSource == 'EXCHANGE' &&
            row?.orderSettlement?.proofOperationFileApproved
          "
          class="size-row label-data tappable"
          title="Anexar os documentos da liquidação e operação"
          (click)="openSettlementDocumentsComponentModal(row?.id)"
          ><img
            class="pr-2"
            src="assets/image/tooltips/upload-documents-green.svg"
        /></span>

        <span
          *ngIf="
            row?.statusFlow == 'PAID' &&
            row?.orderSource != 'EXCHANGE' &&
            (!row?.orderSettlement?.exchangeContractFile ||
              !row?.orderSettlement?.proofOperationFile ||
              !row?.orderSettlement?.contractSettlementNumber) &&
            row?.remmitanceType == 'OUTBOUND' &&
            !row?.orderSettlement?.proofOperationFileApproved
          "
          class="size-row label-data tappable"
          title="Anexar os documentos da liquidação"
          (click)="openSettlementConfirmModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/upload-documents.svg"
        /></span>

        <span
          *ngIf="
            row?.statusFlow == 'PAID' &&
            row?.orderSource != 'EXCHANGE' &&
            (!row?.orderSettlement?.exchangeContractFile ||
              !row?.orderSettlement?.proofOperationFile ||
              !row?.orderSettlement?.contractSettlementNumber) &&
            row?.remmitanceType == 'OUTBOUND' &&
            row?.orderSettlement?.proofOperationFileApproved
          "
          class="size-row label-data tappable"
          title="Anexar os documentos da liquidação"
          (click)="openSettlementConfirmModal(row?.id)"
          ><img
            class="pr-2"
            src="assets/image/tooltips/upload-documents-green.svg"
        /></span>

        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            !row?.confirmationSlip &&
            !row?.confirmationTreasury
          "
          class="size-row label-data tappable"
          title="Adicionar informações da tesouraria"
          (click)="openTreasuryInfoModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/treasury-info.svg"
        /></span>

        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            !row?.confirmationSlip &&
            row?.confirmationTreasury
          "
          class="size-row label-data tappable"
          title="Editar informações"
          (click)="openTreasuryInfoModal(row?.id)"
          ><img
            class="pr-2"
            src="assets/image/tooltips/treasury-info-success.svg"
        /></span>

        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            row?.confirmationTreasury &&
            !row?.confirmationSlip
          "
          class="size-row label-data tappable"
          title="Informações para boletar no Exchange"
          (click)="openExchangeInfoModal(row?.id)"
          openPaymentConfirmModal
          ><img class="pr-2" src="assets/image/tooltips/exchange-info.svg"
        /></span>

        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            row?.confirmationTreasury &&
            row?.confirmationSlip
          "
          class="size-row label-data tappable"
          title="Confirmar recebimento em reais"
          (click)="openPaymentConfirmModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/confirm-reais.svg"
        /></span>

        <span
          *ngIf="
            row?.statusFlow == 'IDENTIFIED_PAYMENT' &&
            row?.remmitanceType == 'OUTBOUND'
          "
          class="size-row label-data tappable"
          title="Confirmar liquidação no exterior"
          (click)="openSettlementInfoModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/confirm-exterior.svg"
        /></span>

        <span
          *ngIf="
            row?.statusFlow == 'IDENTIFIED_PAYMENT' &&
            row?.remmitanceType == 'INBOUND'
          "
          class="size-row label-data tappable"
          title="Confirmar pagamento no Brasil"
          (click)="openSettlementConfirmModal(row?.id)"
          ><img
            class="pr-2"
            src="assets/image/tooltips/confirm-payment-brasil.svg"
        /></span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; let i = index; columns: displayedColumns">
    </mat-row>
  </mat-table>
</div>

<mat-paginator
  class="custom-paginator"
  [pageIndex]="pageNumber"
  [pageSize]="pageSize"
  [length]="totalElements"
  (page)="onPageChange($event)"
  [pageSizeOptions]="[5, 10, 25, 50]"
  showFirstLastButtons
></mat-paginator>
